export default {
  home: {
    header: {
      title: 'CAT4MRO',
      supplier: {
        subtitle_1: 'It allows you to expose your <b> items directly </b> to the <b> buyers </b> of mining.',
        subtitle_2: 'In <b> CAT4MRO </b>, for each <b> purchase need </b> raised by a buyer with <b> technical characteristics </b> similar to an item in your catalog, your offer will be displayed <b > automatically </b>.',
      },
      buyer: {
        subtitle_1: '<b> CAT4MRO takes </b> the <b> purchase need </b> raised by buyers and compares them against supplier catalogs. <b> As a result, CAT4MRO delivers the list of suppliers with items with high matches at the technical specification level. </b>',
      },
    },
    body: {
      sections: {
        title: 'Profits',
        supplier: {
          cards_1: 'Visibility of your <strong> items </strong> directly at the origin of the <strong> demand </strong>',
          cards_2: 'Find out which companies are looking for <strong> items </strong> from your <strong> catalog. </strong>',
          cards_3: 'Ranking of <strong> categories </strong> and <strong> most searched items </strong>',
          cards_4: 'Consult by <strong> industry </strong> which <strong> items </strong> of your catalog are the <strong> most required </strong>',
          cards_5: 'Know the <strong> demand </strong> of your <strong> items </strong> by <strong> geographical area </strong>',
          cards_6: 'Lower <strong> costs </strong> of <strong> contact </strong> and <strong> transaction </strong>',
        },
        buyer: {
          cards_1: 'CAT4MRO allows you to quickly and easily find suppliers, products or services based on the item\'s description.',
          cards_2: 'CAT4MRO has more than 1,700 catalogs from different suppliers, with more than 1.2 million items',
          cards_3: 'More than 300 different categories of materials and services available',
          cards_4: 'Smart search engine based on technical specifications of materials or services',
          cards_5: 'With CAT4MRO you will be able to give traceability to your search and supplier selection process.',
          cards_6: 'Lower contact and transaction costs',
        },
      },
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/en-us/home.js